export default __webpack_public_path__ + "images/erickson-living-knockout-main.svg?97533bd5a7f4677434c7dfd7fc01911d";